// removed by extract-text-webpack-plugin
module.exports = {"logo":"src-components-global----Logo-module---logo---131af","whiteLogo":"src-components-global----Logo-module---whiteLogo---2xElW","fadeIn":"src-components-global----Logo-module---fadeIn---2DyeS","fadeInUp":"src-components-global----Logo-module---fadeInUp---3z6Y9","fadeInUpCenter":"src-components-global----Logo-module---fadeInUpCenter---1-3k1","fadeInUpSmall":"src-components-global----Logo-module---fadeInUpSmall---3jYkX","textCoverIn":"src-components-global----Logo-module---textCoverIn---qcQr-","textCoverOut":"src-components-global----Logo-module---textCoverOut---1JWct"};


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Logo.module.scss
// module id = 480
// module chunks = 114276838955818